/* src/app/modules/expense/correos-ia/connect-mail-account-dialog.component.css */
.w-100 {
  width: 100%;
}
::ng-deep .connect-mail-account-dialog mat-form-field {
  display: block;
  margin-bottom: 4px;
}
.field-help {
  display: block;
  margin-top: -4px;
  margin-bottom: 16px;
}
/*# sourceMappingURL=connect-mail-account-dialog.component.css.map */
